export default [
    {
        path: 'my-invoices',
        name: 'invoices-my-invoices',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_invoices').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'invoices-my-invoices-list' },
        children: [
            {
                path: '',
                name: 'invoices-my-invoices-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_invoices').ucFirst();
                    },
                },
                component: () => import('@/views/pages/invoices/invoices/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'invoices-my-invoice-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'invoices-my-invoice-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'accessible-invoices',
        name: 'invoices-accessible-invoices',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.accessible_invoices').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'invoices-accessible-invoices-list' },
        children: [
            {
                path: '',
                name: 'invoices-accessible-invoices-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.accessible_invoices').ucFirst();
                    },
                },
                component: () => import('@/views/pages/invoices/invoices/accessible.vue'),
                props: { accessible: true },
            },
            {
                path: 'create',
                name: 'invoices-accessible-invoice-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'invoices-accessible-invoice-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { accessible: true },
            },
        ]
    },
];